/**
 * Remove hard-coded text colors from Froala/HTML fragments.
 *
 * Pastes from Word / Google Docs often include inline `color: #ffffff` (or
 * similar). That overrides theme text color and becomes invisible on a light
 * background. Class-based Froala styles (`is-white`, `is-highlighted`, …) and
 * non-color inline styles (background, font-size, alignment) are preserved.
 *
 * @param {string|null|undefined} html
 * @returns {string}
 */
export function stripInlineTextColors(html) {
    if (html == null) {
        return '';
    }

    if (typeof html !== 'string') {
        return html;
    }

    if (html === '' || !/[cC]olor\s*[:=]/.test(html)) {
        return html;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div id="__strip-inline-text-colors">${html}</div>`, 'text/html');
    const root = doc.getElementById('__strip-inline-text-colors');

    if (!root) {
        return html;
    }

    root.querySelectorAll('[style]').forEach(element => {
        const style = element.getAttribute('style');
        if (!style) {
            return;
        }

        const cleaned = style
            .split(';')
            .map(part => part.trim())
            .filter(Boolean)
            .filter(declaration => !/^color\s*:/i.test(declaration))
            .join('; ');

        if (cleaned) {
            element.setAttribute('style', cleaned);
        } else {
            element.removeAttribute('style');
        }
    });

    // Legacy Word / HTML color attribute (e.g. <font color="#ffffff">).
    root.querySelectorAll('[color]').forEach(element => {
        element.removeAttribute('color');
    });

    return root.innerHTML;
}
